import React, { useState } from "react";
import "./styles.css";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Select,
  InputNumber,
  Button,
  DatePicker,
  Input,
  Space,
} from "antd";
const FormItem = Form.Item;
const Option = Select.Option;

const GastosForm = () => {
  const [gastos, setGastos] = useState([]);
  const [value, setValue] = useState({});

  const handleCategoria = (e) => {
    console.log("e", e);
  };
  let handleAddBtn = () => {
    alert("Adding");
  };

  const onFinish = (values) => {
    console.log(values);
  };

  return (
    <div className="gastosdiv">
      <Form
        // name="gastosform"
        onFinish={onFinish}
        name="dynamic_form_nest_item"
        style={{ maxWidth: 1100, columGap: "8px" }}
        autoComplete="off"
      >
        <FormItem label="Formulario de los Gastos">
          <span className="ant-form-text">Fabrica</span>
        </FormItem>
        <div className="title">
          <h1 className="fabrica">Fabrica</h1>
        </div>
        <div className="top">
          <FormItem hasFeedback label="Billetera" name="billetera">
            {/* <span className="billetera">Billetera:</span> */}
            <Select placeholder="Caja" style={{ width: 200 }}>
              <Option value="cajafabrica">Caja Fabrica</Option>
              <Option value="banco">Patagonia</Option>
              <Option value="beta">Guille y Beta</Option>
              <Option value="ale">Ale</Option>
              <Option value="martinyhannah">Martin y Hannah</Option>
            </Select>
          </FormItem>
          <FormItem label="Pagado o Debido">
            <Select placeholder="Pagado" style={{ width: 200 }}>
              <Option value="paga">Pagado</Option>
              <Option value="debo">Debido</Option>
            </Select>
          </FormItem>
          {/* <span className="fit">Fecha:</span> */}

          <FormItem label="Fecha" name="date">
            <DatePicker disableFuture />
          </FormItem>
        </div>
        <div className="bottom">
          <Form.List name="users">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{
                      align: "end",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 4,
                    }}
                    // align="baseline"
                  >
                    <FormItem
                      label="Nombre"
                      {...restField}
                      name={[name, "first"]}
                      rules={[
                        { required: true, message: "Missing first name" },
                      ]}
                    >
                      <Input placeholder="Nombre" style={{ width: 200 }} />
                    </FormItem>

                    <FormItem hasFeedback label="Categoria" name="categoria">
                      {/* <span className="ant-form-text">Categoria de Gasto:</span> */}
                      <Select
                        placeholder="Area"
                        style={{ width: 200, padding: 0 }}
                      >
                        <Option value="edificio">Edificio</Option>
                        <Option value="limpieza">Limpieza</Option>
                        <Option value="materiaprima">Materia Prima</Option>
                        <Option value="sueldos">Sueldos</Option>
                      </Select>
                    </FormItem>

                    <FormItem label="Item" name="item">
                      {/* <span className="ant-form-text">Item:</span> */}
                      {
                        <Select placeholder="Detalle" style={{ width: 200 }}>
                          <Option value="agua">Agua</Option>
                          <Option value="energia">Energia</Option>
                          <Option value="alquiler">Alquiler</Option>
                        </Select>
                      }
                    </FormItem>
                    {/* <span className="fit">Monto:</span> */}
                    <FormItem label="Monto" name="monto">
                      <InputNumber
                        min={1}
                        max={20000000}
                        placeholder="$"
                        style={{ width: 150 }}
                      />
                    </FormItem>
                    <div className="minus">
                      <MinusCircleOutlined
                        height={"1em"}
                        onClick={() => remove(name)}
                        style={{
                          display: "flex",

                          justifyContent: "flex-end",
                        }}
                      />
                    </div>
                  </Space>
                ))}
                <div className="addFields">
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{
                        width: 200,
                        alignItems: "center",
                      }}
                    >
                      Add field
                    </Button>
                  </Form.Item>
                </div>
              </>
            )}
          </Form.List>

          <div className="addBtn">
            <FormItem wrapperCol={{ span: 12, offset: 6 }}>
              <Button type="primary" htmlType="submit">
                Agregar
              </Button>
            </FormItem>
          </div>
        </div>
      </Form>
    </div>
  );
};
export default GastosForm;
